<template>
  <div class="miya-historicalOrders" id="miya-historicalOrders">
    <div class="pageBox">
      <h1 class="title1 fontSH">{{$t('menu.m4')}}</h1>
      <div class="totalList">
        <div class="item-content">
          <i class="icon icon0"></i>
          <div class="text">
            <p class="name">{{totalList[0].name}}</p>
            <p class="value"><miya-number :round="1" :dataValue="totalList[0].value"></miya-number></p>
          </div>
        </div>
        <div class="div1"></div>
        <div class="line"></div>
        <div class="div1"></div>
        <div class="item-content">
          <i class="icon icon1"></i>
          <div class="text">
            <p class="name">{{totalList[1].name}}</p>
            <p class="value"><miya-number :round="1" :dataValue="totalList[1].value"></miya-number></p>
          </div>
        </div>
        <div class="div1"></div>
        <div class="line"></div>
        <div class="div1"></div>
        <div class="item-content">
          <i class="icon icon2"></i>
          <div class="text">
            <p class="name">{{totalList[2].name}}</p>
            <p class="value"><miya-number :round="1" :dataValue="totalList[2].value"></miya-number></p>
          </div>
        </div>
        <div class="div1"></div>
      </div>
      <div class="search-box">
        <check-list class="checkList" :list="tabList" :default="[activeTab]" @change="changeTab"></check-list>
        <div class="search-input">
          <el-input size="medium" v-model="searchText" :placeholder="$t('pAgent.placeholderSearch1')" clearable @change="getDataList()"><i slot="suffix" class="el-input__icon el-icon-search"></i></el-input>
        </div>
      </div>
      <div class="table-data">
        <el-table ref="multipleTable" v-loading="tableLoading" :data="tableData" :max-height="tableHeight" style="width: 100%">
          <el-table-column prop="orderId" :label="$t('pAgent.htname1')" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="shopName" :label="$t('pAgent.htname2')" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="price" :label="$t('pTraffic.amount')" show-overflow-tooltip width="160">
            <template slot-scope="scope">
              <p>${{scope.row.priceDao}}  / ￥{{scope.row.price}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('pAgent.htname4')" show-overflow-tooltip width="160">
            <template slot-scope="scope">
              <img class="icon-status" v-if="scope.row.status === 0" src="@assets/images/dynamic/history2.svg">
              <img class="icon-status" v-if="scope.row.status === 1" src="@assets/images/dynamic/history3.svg">
              <span>{{scope.row.status === 0 ? $t('pAgent.htype1') : $t('pAgent.htype2')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('pAgent.htname5')" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="payTime" :label="$t('pAgent.htname6')" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.payTime ? scope.row.payTime : '--'}}</span>
            </template>
          </el-table-column>
          <div slot="empty" class="table_nodata">
            <img v-if="!tableLoading" class="nodata" src="@/assets/images/home/noData.png" height="240" alt="" />
            <p v-if="!tableLoading" class="nodataText">{{$t('home.noData')}}</p>
          </div>
        </el-table>
      </div>  
      <div class="price-box">
        <div class="selection"> 
        </div>
        <div class="pagination">
          <el-pagination size="medium" :layout="pageWidth < 800 ? 'total,prev, pager, next' : 'total, sizes, prev, pager, next'" :page-sizes="[8,20,30,50]" :page-size="pageSize" :current-page="page" :pager-count="5" :total="total" @size-change='changeDataSize'  @current-change='changePage'></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import miyaNumber from '@components/miyaNumber.vue'
import checkList from '@components/checkList.vue'
import moment from 'moment'
export default {
  data () {
    return {
      totalList: [
        {name: '', value: 0},
        {name: '', value: 0},
        {name: '', value: 0},
      ],
      tabList: [
        {name: '', value: -1}, 
        {name: '', value: 0}, 
        {name: '', value: 1}, 
      ],
      tableData: [],
      activeTab: -1,
      searchText: '',
      priceTop: 0,
      total: 0,
      page: 1,
      pageSize: 8,
      tableLoading: false,
      selectList: [],
      tableHeight: 0,
    }
  },
  created () {
    this.getDataList()
    this.getTotal()
  },
  mounted () {  
    this.getData()
    this.initEvent()
    this.setTableHeight()
  },
  methods: {
    getData () {
      this.totalList[0].name = this.$t('pAgent.htitl1')
      this.totalList[1].name = this.$t('pAgent.htitl2')
      this.totalList[2].name = this.$t('pAgent.htitl3')
      this.tabList[0].name = this.$t('pAgent.all')
      this.tabList[1].name = this.$t('pAgent.htype1')
      this.tabList[2].name = this.$t('pAgent.htype2')
    },
    getTotal () {
      this.$get(`/OrderList/OrderAnlays`).then(res => {
        if (res.code === 200) {
          this.totalList[0].value = res.result.all
          this.totalList[1].value = res.result.unPaid
          this.totalList[2].value = res.result.paid
        }
      })
    },
    getDataList () {
      this.tableData = []
      this.tableLoading = true
      let params = {
        status: this.activeTab,
        page: this.page,
        limit: this.pageSize
      }
      if (this.searchText) {
        params.key = this.searchText
      }
      this.$get(`/OrderList/Load`, params).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.count
        }
      })
    },
    changeDataSize (pageSize) {
      this.page = 1
      this.pageSize = pageSize
      this.getDataList()
    },
    changePage (page) {
      this.page = page
      this.getDataList()
    },
    changeTab (list) {
      this.activeTab = list[0].value
      this.getDataList()
    },
    resetTop () {
      let height = $('#miya-historicalOrders').innerHeight()
      let scrollT = $(window).scrollTop()
      let wH = window.innerHeight
      let top = scrollT + wH
      if (top < height) {
        this.priceTop = top - 65
      } else {
        this.priceTop = height - 65
      }
    },
    setTableHeight () {
      if (this.$refs.multipleTable) {
        setTimeout(() => {
          this.tableHeight = $('#miya-historicalOrders').innerHeight() - 360
          if(this.pageWidth < 800) {
            this.tableHeight = 600
          }
          this.$refs.multipleTable.doLayout()       
        }, 100);
      }
    },
    initEvent () {
      $(window).bind('resize', () => {
        this.setTableHeight()
      })
    },
  },
  beforeDestroy () {
    // $(window).unbind('resize')
  },
  watch: {
    language () {
      this.getData()
    },
  },
  components: {miyaNumber, checkList}
}
</script>
<style scoped lang="stylus">
.miya-historicalOrders
  height 100%
  overflow-y hidden
  .pageBox
    min-height 100%
    padding 40px 40px 24px 40px
    position relative
  .title1
    color $c1
    font-size 28px
    margin 10px 0 32px 0
  .search-box
    display flex
    .checkList
      flex 1  
      .item
        width 130px
    .search-input
      width 20%
  .totalList
    display flex
    border-bottom 1px solid $c4
    margin-bottom 24px
    .div1
      flex 1
    .item-content
      display flex
      margin-bottom 16px
      .icon
        width 30px
        height 30px
        margin-right 16px
      .icon0
        background-image url('../../assets/images/dynamic/history1.svg')
        background-size 100% 100%
      .icon1
        background-image url('../../assets/images/dynamic/history2.svg')
        background-size 100% 100%
      .icon2
        background-image url('../../assets/images/dynamic/history3.svg')
        background-size 100% 100%
      .text
        color $c1
        .name
          font-size $f14
          margin-bottom 10px
        .value
          font-size 28px
    .line
      width 1px
      height 40px
      background-color $c5
      top calc(50% - 20px)
  .table-data
    margin 24px 0 54px 0
    min-height 200px
    .qrcode
      color $c1
      font-size $f14
      padding 4px 16px
      position relative
      display inline-block
      border 1px solid #E0E0E0
    .type-name
      color $c1
      font-size $f14
      fontWeight()
      margin-bottom 6px
    .value-box
      line-height 20px
      color $c1
      font-size $f14
      display flex
      .type
        fontWeight()
        color $c8
    .icon-status
      width 13px
      margin-right 6px
      position relative
      top 2px
  .price-box
    position absolute
    z-index 5
    left 0
    bottom 0
    width 100%
    border-top 1px solid $c4
    background-color $c7
    display flex
    .selection
      padding 15px 0 15px 36px
      line-height 36px
      display flex
      flex 1
      .slection-box
        display flex
        line-height 32px
        .selectText, .unit
          font-size $f14
          margin-right 10px
          color $c1
        .total
          color $c8
          font-size $f20
          fontWeight()
          margin-right 6px
        .btn-mutRenew
          margin-left 40px
    .pagination
      padding 16px 32px 16px 36px
      display flex
@media screen and (max-width: 800px)
  .miya-historicalOrders
    overflow-y auto
    .title1
      margin-bottom 1rem
      line-height 1.5rem  
    .totalList
      flex-wrap wrap
      .item-content
        width 40%
        margin-bottom 1rem
      .line
        &:nth-of-type(7)
          display none
    .search-box
      display block
      .checkList
        width 100%
        margin-bottom 0.2rem
      .search-input
        width 10rem
    .table-data
      margin 1rem 0 2rem 0
    .price-box
      .pagination
        padding 0.5rem
      .selection
        padding 0
</style>
<style lang="stylus">
.miya-historicalOrders
  .el-button--primary
    background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%);
  .search-box
    .el-input__inner
      background-color $c7
    .el-input--medium .el-input__icon
      color $c1
      fontWeight()
  .el-table .el-table__cell
    padding 18px 0
  .miya-checkList
    .item
      width 130px
  .btn-delete   
    border 1px solid transparent
    background-color $c5
    color $c1
    &:hover
      background-color $c4
      color $c1
@media screen and (max-width: 800px)
  .miya-historicalOrders
    .miya-checkList
      .item
        width 4.5rem
        margin-right 0.5rem
</style>